import { render } from "./FirstTimersList.vue?vue&type=template&id=17b6d56b&scoped=true"
import script from "./FirstTimersList.vue?vue&type=script&lang=js"
export * from "./FirstTimersList.vue?vue&type=script&lang=js"

import "./FirstTimersList.vue?vue&type=style&index=0&id=17b6d56b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b6d56b"]])

export default __exports__